export default __webpack_public_path__ + "static/media/Fjord.676f9f4d.png";